import formatDollar from '../formatDollar';

const wholesaleMap = {
  'price': 'wholesale_price',
  'sale_price': 'wholesale_sale_price',
  'is_available': 'wholesale_is_available',
  'is_featured': 'wholesale_is_featured',
  'pricing_tiers': 'wholesale_pricing_tiers',
  'add_to_cart': 'wholesale_add_to_cart',
};

export function card( item, index ) {
  if ( siteInfo?.search?.isWholesale ) {
    Object.keys( wholesaleMap ).forEach( ( key ) => {
      if ( item[key] ) {
        item[key] = item[wholesaleMap[key]];
      }
    } );
  }
  let images = '';
  const imageClass = item.images.length > 1 ? 'group-hover:first:opacity-0 first:opacity-100 opacity-0 group-hover:opacity-100 first:duration-300' : '';
  const loading = index > 3 ? 'loading="lazy"' : 'loading="eager"';
  for ( let i = 0; i < 2; i++ ) {
    if ( typeof item.images[i] === 'undefined' ) break;
    images += `
      <div class="relative grid col-start-1 row-start-1 place-items-center first:z-10 ${imageClass}">
        <img src="${item.images[i]}" alt="Photo ${i+1} of ${item.title}" class="object-contain h-full size-full max-h-[268px]" ${loading} />
      </div>
    `;
  }

  let salePrice = formatDollar( item.sale_price );

  salePrice = item.sale_price ? `
    <span class="text-brand-red peer is-visible">${salePrice}</span>
  ` : ``;

  let displayPrice = formatDollar( item.price );

  displayPrice = item?.stock <= 0 ? `
    <p class="flex items-center gap-x-2.5">
      <span class="font-bold paragraph-large text-brand-red">${displayPrice}</span>
    </p>
  ` : `
    <span class="peer-[.is-visible]:x-[text-brand-sale-gray,line-through]">${displayPrice}</span>
  `;

  let discount = item?.sale_price ? new Intl.NumberFormat( navigator.language, {
    style: 'percent',
    minimumFractionDigits: 0,
    maximumFractionDigits: 0,
  } ).format( ( item.price - item.sale_price ) / item.price ) : null;

  discount = discount ? `
    <p class='price-discount text-white py-0.5 px-1.5 bg-brand-red rounded w-fit font-semibold text-xs'>Save ${discount}</p>
  ` : '';

  if ( discount.length === 0 && item.pricing_tiers.length > 0 ) {
    discount = `<p class='price-discount text-white py-0.5 px-1.5 bg-brand-red rounded w-fit font-semibold text-xs'>Save on Qty</p>`;
  }

  const buttonDisabledClasses = item.stock === 0 || !item.add_to_cart ? 'opacity-50 pointer-events-none' : '';

  let tags = '';
  if ( item.status.length > 0 ) {
    item.status.forEach( ( status ) => {
      if ( ['New', 'Rebate', 'Scratch and Dent', 'Open Box'].includes( status ) ) {
        if ( status === 'New' ) {
          status = 'New Product';
        }

        const color = status === 'New Product' ? 'bg-brand-light-gray text-brand-dark-charcoal' : 'bg-brand-red text-white';

        tags += `
          <div class="py-1.5 px-2.5 ${color} rounded font-bold text-sm">
            ${status}
          </div>
        `;
      }
    } );
  }

  if ( tags.length > 0 ) {
    tags = `
      <div class="pointer-events-none absolute top-0 z-50 left-0 w-full flex flex-wrap gap-2.5">
        ${tags}
      </div>
    `;
  }

  return `
    <div class="relative flex flex-col h-full">
      ${tags}
      <div class="relative grid w-full h-[268px] grid-cols-1 grid-rows-1 group">
        ${images}
        <a class="absolute inset-0 z-20" href="${window.siteInfo.url}/product/${item.slug}"></a>
      </div>
    </div>

    <div class="flex flex-col justify-between grow gap-y-2.5">
      <a class="font-bold duration-300 woocommerce-loop-product__title text-brand-dark-charcoal hover:text-brand-charcoal line-clamp-3" href="${window.siteInfo.url}/product/${item.slug}">
        ${item.title}
      </a>

      <div class="mt-auto">
        <p>${item.sku}</p>
        <div class='flex items-center gap-2.5 mb-5 mt-2.5 price'>
          ${salePrice}
          ${displayPrice}
          ${discount}
        </div>
      </div>

      <p class="paragraph-xsmall">
        <strong>Estimated Ship Date:</strong>
        ${item.estimated_ship_date}
      </p>

      <form class="paragraph-xsmall">
        <label class="inline-flex gap-2.5 items-center">
          <input type="checkbox" name="product_comparison" value="${item.id}" ${JSON.parse( sessionStorage.getItem( 'compareProducts' ) || '[]' ).includes( item.id ) ? 'checked' : ''} />
          <span class="paragraph-xsmall">Add to Compare</span>
        </label>
      </form>

      <form action="${window.siteInfo?.addToCartUrl}" method="post" class="!flex items-stretch justify-between gap-x-4 cart">
        <div class="quantity">
          <input type="number" name="quantity" value="1" min="1" max="${item?.stock ?? 0}" step="1"
            class="${buttonDisabledClasses} font-bold h-full rounded input-text qty text border-brand-dark-charcoal text-brand-dark-charcoal w-full">
        </div>

        <input type="hidden" name="add-to-cart" value="${item.id}">

        <button type="submit"
          class="add_to_cart_button btn px-0.5 after:bg-brand-off-black w-full ${buttonDisabledClasses}"
        >
          <span class="flex items-center gap-x-1.5">
            Add to Cart

            <svg class='icon size-5'>
              <use xlink:href='#icon-cart'></use>
            </svg>
          </span>
        </button>
      </form>
    </div>
  `;
}
